import {useState, useEffect} from 'react';
import {useAuthContext} from '../context/AuthContext';
import {AccountClaims} from '../types';

interface UserInfo {
    oid: string;
    preferredUsername: string;
    name: string;
}

export type UserInfoState =
    | {status: 'loading'}
    | {status: 'success'; data: UserInfo}
    | {status: 'error'; error: string};

const useUserInfo = (): UserInfoState => {
    const {accountClaims} = useAuthContext();
    const [state, setState] = useState<UserInfoState>({status: 'loading'});

    useEffect(() => {
        if (accountClaims) {
            getUserInfo(accountClaims);
        } else {
            setState({status: 'error', error: 'No account found'});
        }
    }, [accountClaims]);

    const getUserInfo = async (claims: AccountClaims) => {
        try {
            if (claims.oid && claims.preferred_username && claims.name) {
                setState({
                    status: 'success',
                    data: {
                        oid: claims.oid,
                        preferredUsername: claims.preferred_username,
                        name: claims.name
                    }
                });
            } else {
                setState({
                    status: 'error',
                    error: 'Incomplete user info received'
                });
            }
        } catch (error) {
            setState({status: 'error', error: 'Failed to fetch user info'});
            console.error('Error acquiring token:', error);
        }
    };

    return state;
};

export default useUserInfo;
